/* eslint-disable unicorn/filename-case */
const removeNonNumericCharacters = string => string.replace(/\D/g, '');

const removeLeadingZero = string => {
  let result = string;

  if (string[0] === '0') {
    result = string.slice(1, string.length);
  }

  return result;
};

const reduceToMaxLength = (string, maxlength) => {
  // Reduce length of input value, so that formatted str is within maxlength
  const maxSymbolCharLength = 1 + Math.ceil((maxlength - 1) / 3 - 1); // 1 '$', plus max number of commas

  const maxDigitLength = maxlength - maxSymbolCharLength;
  return maxlength ? string.slice(0, maxDigitLength) : string;
};

var dollarFormat = ((str, maxlength = 0) => {
  let result = removeNonNumericCharacters(str);
  result = removeLeadingZero(result);
  result = reduceToMaxLength(result, maxlength);
  result = result ? `$${result.replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')}` : '';
  return result;
});

export { dollarFormat as default };
